import { useTranslation } from 'react-i18next';
import { Icon } from '../../components/icons';
import type { PlanFeatureKey } from '../../lib/api';
import { useUpgradeTarget } from './plan';

/**
 * The plan's name beside a navigation entry the plan turns off (D-183):
 * « Pro » on Campagnes for a Starter workspace, read as « Inclus dans Pro ».
 * A padlock alone when no plan opens it; nothing when it is open. Fed by
 * `plan.upgradeFor` of `/workspaces/current` only — never the catalogue — so
 * it is the same for every role.
 */
export function PlanBadge({ feature, onDark = false }: { feature: PlanFeatureKey; onDark?: boolean }) {
  const { t } = useTranslation();
  const { locked, target } = useUpgradeTarget(feature);
  if (!locked) return null;
  const label = target ? t('upsell.includedIn', { plan: target.name }) : t('planLock.lockLabel');
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      className={`inline-flex shrink-0 items-center gap-1 rounded-full px-[7px] text-[11px] font-bold leading-[18px] ${
        onDark ? 'bg-primary-100 text-primary-800' : 'bg-primary-50 text-primary-700'
      }`}
    >
      {target ? target.name : <Icon name="lock" className="my-[3px] size-3" />}
    </span>
  );
}
